module.exports = __webpack_public_path__ + "img/01.7a735f45.jpg";